import { configureStore } from '@reduxjs/toolkit'
import restaurantFeatures from '../features/restaurant/restaurant'


export default configureStore({
    reducer: {
        restaurant: restaurantFeatures
    },
})
